<template>
	<div>
		<v-autocomplete
			:items="param.choices"
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="select-field"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			clearable
			:readonly="readonly"
			:multiple="multiple"
			chips
			:dense="dense"
			:name="param.name"
			:small-chips="dense"
			:deletable-chips="!readonly"
			item-text="1"
			item-value="0"
			:value="value"
			@input="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>
		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false
		}
	},
	computed: {
		multiple () {
			if (!this.param) return false
			return this.param.type.indexOf('multi-select') === 0
		}
	},
	methods: {
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/select.vue